import { render } from "./CalendarDayCurrent.vue?vue&type=template&id=61a20d76&ts=true"
import script from "./CalendarDayCurrent.vue?vue&type=script&lang=ts"
export * from "./CalendarDayCurrent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__